// Fatia S1: termos de uso.
import { Link } from 'react-router-dom'
import { TRIAL_DAYS } from '@impulso/shared'
import { LEGAL } from '../../features/public/legal'
import '../../features/public/site.css'

export default function Terms() {
  return (
    <article className="legal">
      <h1>Termos de uso</h1>
      <p className="small muted">Última atualização: {LEGAL.updatedAt}</p>
      <p>Estes termos regulam o uso do {LEGAL.brand}, serviço oferecido por {LEGAL.company}, {LEGAL.cnpj}. Ao criar uma conta você concorda com eles e com a <Link to="/privacidade">política de privacidade</Link>.</p>

      <h2>1. O que é o serviço</h2>
      <p>O {LEGAL.brand} é uma plataforma que se conecta às suas contas de anúncio (Google Ads, Meta, TikTok e OpenAI Ads) e, se você quiser, ao Google Analytics, para mostrar resultados em linguagem simples, sugerir melhorias e, quando você autorizar, aplicar mudanças nas campanhas dentro dos limites definidos por você.</p>

      <h2>2. Conta e acesso</h2>
      <ul>
        <li>Você deve informar dados verdadeiros e manter sua senha em sigilo. Recomendamos ativar a verificação em duas etapas.</li>
        <li>O titular da conta (dono) responde pelas pessoas que convidar e pelos papéis que atribuir.</li>
        <li>Agências declaram ter autorização dos seus clientes para conectar e gerenciar as contas de anúncio deles.</li>
      </ul>

      <h2>3. Contas de anúncio e pagamentos às plataformas</h2>
      <ul>
        <li>Os anúncios são pagos por você diretamente ao Google, à Meta, ao TikTok e à OpenAI. O {LEGAL.brand} não intermedeia nem recebe esses valores.</li>
        <li>Você continua sujeito aos termos e às políticas de publicidade do Google, da Meta, do TikTok e da OpenAI. Anúncios reprovados ou contas bloqueadas por essas plataformas não são responsabilidade do {LEGAL.brand}.</li>
      </ul>

      <h2>4. Sugestões, piloto automático e limites</h2>
      <ul>
        <li>Sugestões e estimativas são baseadas nos dados disponíveis e não garantem resultado. Valores “estimados” são indicados como tal.</li>
        <li>No modo “Só sugerir”, nada é alterado sem a sua confirmação. Nos modos “Copiloto” e “Automático”, o sistema age somente dentro dos limites de segurança configurados (teto mensal, custo máximo por cliente e variação diária).</li>
        <li>Toda ação fica registrada no histórico e pode ser desfeita quando a plataforma permitir.</li>
        <li>Textos e ideias gerados por inteligência artificial devem ser revisados por você antes da publicação.</li>
      </ul>

      <h2>5. Planos, teste e cobrança</h2>
      <ul>
        <li>O teste grátis dura {TRIAL_DAYS} dias e não exige cartão.</li>
        <li>A assinatura é mensal e renovada automaticamente. Formas de pagamento: Pix, boleto ou cartão, processados pelo nosso parceiro de pagamentos.</li>
        <li>Sem pagamento, a conta passa para “somente leitura” após 7 dias (o piloto automático é pausado e nada é alterado nas plataformas) e é suspensa após 30 dias.</li>
        <li>Você pode cancelar a qualquer momento, sem multa. O acesso continua até o fim do período já pago. Não há reembolso proporcional de períodos já iniciados, salvo previsão legal.</li>
        <li>Os limites de cada plano estão na página de <Link to="/precos">preços</Link>. O limite de investimento gerenciado é uma referência: ao passar dele, avisamos, sem bloquear seus anúncios.</li>
      </ul>

      <h2>6. Uso aceitável</h2>
      <p>É proibido usar o serviço para anúncios ilegais, enganosos ou que violem as políticas das plataformas; tentar acessar dados de outras contas; fazer engenharia reversa; ou sobrecarregar o sistema de forma automatizada.</p>

      <h2>7. Disponibilidade e responsabilidade</h2>
      <p>Trabalhamos para manter o serviço disponível, mas ele depende também das APIs do Google, da Meta, do TikTok e da OpenAI, que podem mudar ou ficar indisponíveis. Nossa responsabilidade se limita ao valor pago pela assinatura nos 3 meses anteriores ao evento, exceto nos casos em que a lei não permitir essa limitação.</p>

      <h2>8. Dados e privacidade</h2>
      <p>O tratamento de dados pessoais segue a <Link to="/privacidade">política de privacidade</Link> e a LGPD. Para agências, oferecemos contrato de tratamento de dados (DPA).</p>

      <h2>9. Encerramento</h2>
      <p>Podemos suspender contas que violem estes termos, avisando sempre que possível. Você pode pedir a exclusão da conta e dos dados a qualquer momento (veja <Link to="/exclusao-de-dados">exclusão de dados</Link>).</p>

      <h2>10. Alterações e foro</h2>
      <p>Mudanças relevantes nestes termos serão avisadas por e-mail com antecedência. Fica eleito o foro do domicílio do consumidor, quando aplicável, ou da sede do {LEGAL.brand}.</p>

      <h2>Contato</h2>
      <p>{LEGAL.supportEmail}</p>
    </article>
  )
}
